import { mapActions } from 'vuex'
import { padStart, range } from 'lodash'

import globaltypes from '../../store/globaltypes'
import changelog from '../../../changelog'
import notifications from '../../services/NotificationService'
import { isMobileApp } from '../../helpers/platform'
import config from '../../config'

export default {
  name: 'settings',
  components: {},
  props: [],
  data () {
    return {
      showPermissionSettings: isMobileApp(),
      version: '1.1.4',
      changelog,
      showChangelog: false,
      panel: [true],
      verifyDelete: false,
      reallySure: false,
      hasPermission: true,
      multiLanguage: config.multiLanguage,
      notificationIntervalDaySetting: notifications.getWeekDaySetting(),
      notificationIntervalHourSetting: notifications.getHourSetting(),
      notificationIntervalMinuteSetting: notifications.getMinuteSetting(),
      notificationIntervalSetting: notifications.getIntervalSetting(),
      notificationIntervalHourOptions: range(0, 24).map(x => padStart(x, 2, '0')),
      notificationIntervalMinuteOptions: range(0, 60).map(x => padStart(x, 2, '0'))
    }
  },
  computed: {
    notificationOptions () {
      return [
        { id: 0, label: this.$t('settings.no_notifications') },
        { id: 1, label: this.$t('settings.daily_notifications') },
        { id: 2, label: this.$t('settings.weekly_notifications') }
      ]
    },
    notificationIntervalDayOptions () {
      return [
        { id: 0, label: this.$t('settings.monday') },
        { id: 1, label: this.$t('settings.tuesday') },
        { id: 2, label: this.$t('settings.wednesday') },
        { id: 3, label: this.$t('settings.thursday') },
        { id: 4, label: this.$t('settings.friday') },
        { id: 5, label: this.$t('settings.saturday') },
        { id: 6, label: this.$t('settings.sunday') }
      ]
    },
    showWeekDaySetting () {
      return this.notificationIntervalSetting == 2
    }
  },
  mounted () {
    notifications.hasPermission().then(val => {
      this.hasPermission = val
    })
  },
  methods: {
    ...mapActions({
      deletAll: globaltypes.planning.actions.deleteAll,
      setLocale: globaltypes.user.actions.setLocale,
      scheduleNotifications: globaltypes.planning.actions.scheduleNotifications
    }),
    closeDeleteVerification (shouldDelete) {
      if (shouldDelete) {
        this.clear()
      }
      this.reallySure = false
      this.verifyDelete = false
    },
    clear () {
      this.deletAll()
      this.$ga.event({
        eventCategory: 'Planning',
        eventAction: 'Delete All'
      })
    },
    selectLocale (locale) {
      this.setLocale(locale)
    },
    async onRequestPermission () {
      this.hasPermission = await notifications.requestPermission()
    },
    updateNotificationTime () {
      const time = `${this.notificationIntervalHourSetting}:${this.notificationIntervalMinuteSetting}`
      notifications.setTimeSetting(time)
      this.scheduleNotifications()
    }
  },
  watch: {
    notificationIntervalDaySetting (val) {
      notifications.setWeekDaySetting(val)
      this.scheduleNotifications()
    },
    notificationIntervalHourSetting () {
      this.updateNotificationTime()
    },
    notificationIntervalMinuteSetting () {
      this.updateNotificationTime()
    },
    notificationIntervalSetting (val) {
      notifications.setIntervalSetting(val)
      this.scheduleNotifications()
    }
  }
}
